module.exports = __webpack_public_path__ + "img/photo.d74ea3f3.jpeg";